import React, { useState, useEffect } from 'react';
import { Row, Col, Label, Input, Card, CardTitle, CardBody, Spinner } from "reactstrap";
import { SEARCH_BY_STORE, SEARCH_VALUES, SEARCH_BY_NAME } from '../../store/search/actionsTypes';
import { useParams } from 'react-router-dom';
import { StoreService } from '../../services/storeService';
import { ApiConstants } from '../../common/apiConstants';
import './button.scss';
import { ProductService } from '../../services/productService';

export default function ProductFilter(props) {
    const storeService = new StoreService();
    const productService = new ProductService();
    const [filters, setFilters] = useState([]);
    const [catalog, setCatalog] = useState([]);
    const [response, setResponse] = useState({ IdTienda: props.params.searchValue, categorias: [] });
    const [clearForm, setClearForm] = useState(false);
    const params = useParams();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        clearFilters();
    }, []);

    const getStoreFilters = async () => {
        setLoading(true);
        let filters = [];

        try {
            switch (props.params.searchType) {
                case SEARCH_BY_STORE:
                    filters = await storeService.getStoreFilters(props.params.searchValue);
                    break;
                case SEARCH_VALUES:
                    filters = await productService.getProductsByKeyWord(props.params.searchValue);
                    break;
                case SEARCH_BY_NAME:
                    const producto = await productService.getProductByName(props.params.searchValue);
                    filters = producto ? [producto] : [];
                    break;
                default:
                    filters = [];
                    break;
            }
        } catch (error) {
            console.error("Error fetching filters", error);
        }

        setFilters(filters ?? []);
        setLoading(false);
    };

    const getStoreCatalog = async (id) => {
        const data = await storeService.getStoreCatalog(id);
        if (data) setCatalog(data);
    };

    const checkboxChange = (event, value) => {
        let previosOptions = response.opciones || [];
        if (event.currentTarget.checked) {
            previosOptions.push(value);
        } else {
            previosOptions = previosOptions.filter(x => x.valor !== value.valor);
        }
        setResponse({ ...response, opciones: previosOptions });
    };

    const applyFilters = () => {
        props.sendFilters({ ...response });
    };

    const clearFilters = () => {
        setClearForm(true);
        setResponse({
            ...response,
            min: null,
            max: null,
            discount: null,
            opciones: [],
            categorias: [],
            nombreProducto: "",
            sort: ApiConstants.SORT.DEFAULT
        });
    };

    const changeFilter = (value, e) => {
        let previosOptions = response.categorias || [];
        if (e.currentTarget.checked) {
            previosOptions.push(value.id);
        } else {
            previosOptions = previosOptions.filter(x => x !== value.id);
        }
        setResponse({ ...response, categorias: previosOptions });
    };

    useEffect(() => {
        getStoreFilters();
        params.id && getStoreCatalog(params.id);
    }, []);

    useEffect(() => {
        if (clearForm) {
            props.sendFilters({ ...response });
            setClearForm(false);
        }
    }, [response]);

    return (
        <React.Fragment>
            <Card style={{marginTop: "20%",
        marginLeft: "2vh",
        height: "60%",
        border: "1px solid #e0e0e0",
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
        backgroundColor: "#fff",
        transition: "box-shadow 0.3s ease"}}>
                <CardBody>
                    <CardTitle className="mb-4">Filtros</CardTitle>
                    <form className="form-horizontal" onSubmit={(e) => e.preventDefault()}>
                        <div className="mt-3 pt-1">
                            <h5 className="font-size-14 mb-4">Rango de Precio</h5>
                            <Row>
                                <Col md="5">
                                    <input name="min" min="0" className="form-control" placeholder="Mínimo" type="number" onChange={(e) => setResponse({ ...response, min: e.target.value })} />
                                </Col>
                                <Col md="5">
                                    <input name="max" min="0" className="form-control" placeholder="Máximo" type="number" onChange={(e) => setResponse({ ...response, max: e.target.value })} />
                                </Col>
                            </Row>
                        </div>

                        <div className="form-group mt-3">
                            <label htmlFor="productName">Buscar por nombre</label>
                            <input
                                type="text"
                                id="productName"
                                className="form-control"
                                placeholder="Escribe el nombre del producto"
                                onChange={(e) => setResponse({ ...response, nombreProducto: e.target.value })}
                            />
                        </div>

                        <hr />
                        {loading ? (
                            <Spinner color="dark" style={{ marginLeft: "43%", marginTop: "12px" }} />
                        ) : (
                            filters
                                .filter(x => x.característica !== "imagen" && x.característica !== "video")
                                .map((x, key) => (
                                    <React.Fragment key={key}>
                                        <div className="mt-3 overflow-y-scroll" style={{ height: "12vh" }}>
                                            <h5 className="font-size-14 mb-3">{x.característica}</h5>
                                            {x.opciones.map((item, i) => (
                                                <div className="custom-control custom-checkbox mt-2" key={i}>
                                                    <Input type="checkbox" onChange={(e) => checkboxChange(e, item)} className="custom-control-input" id={item.valor} />
                                                    <Label className="custom-control-label" htmlFor={item.valor}>{item.valor}</Label>
                                                </div>
                                            ))}
                                        </div>
                                        <hr />
                                    </React.Fragment>
                                ))
                        )}

                        <Row>
                            <Col md="6" className="mt-4">
                                <button className="boton3-fanero btn-block" type="button" onClick={applyFilters}>Aplicar filtros</button>
                            </Col>
                            <Col md="6" className="mt-4">
                                <button className="boton2-fanero btn-block" type="reset" onClick={clearFilters}>Limpiar filtros</button>
                            </Col>
                        </Row>
                    </form>
                </CardBody>
            </Card>

            <Card style={{ height: "fit-content",
        overflowX: "hidden",
        marginLeft: "2vh",
        border: "1px solid #e0e0e0",
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
        backgroundColor: "#fff",
        transition: "box-shadow 0.3s ease"}}>
                <CardBody>
                    <CardTitle className="mb-4">Ordenar</CardTitle>
                    <form className="form-horizontal" onSubmit={(e) => e.preventDefault()}>
                        <div className="mt-3 pt-1">
                            <Row className="form-group">
                                <Label className="col-md-5 col-form-label">Ordenar por</Label>
                                <Col md="7">
                                    <select className="form-control" onChange={(e) => setResponse({ ...response, sort: e.target.value })}>
                                        <option value={ApiConstants.SORT.DEFAULT}>Por defecto</option>
                                        <option value={ApiConstants.SORT.ASC}>Menor Precio</option>
                                        <option value={ApiConstants.SORT.DESC}>Mayor Precio</option>
                                    </select>
                                </Col>
                            </Row>
                        </div>

                        <Row>
                            <Col md="6" className="mt-4">
                                <button className="boton2-fanero btn-block" type="button" onClick={applyFilters}>Ordenar</button>
                            </Col>
                            <Col md="6" className="mt-4">
                                <button className="boton3-fanero btn-block" type="reset" onClick={clearFilters}>Cancelar</button>
                            </Col>
                        </Row>
                    </form>
                </CardBody>
            </Card>

        </React.Fragment>
    );
}
